import type { MouseEventHandler } from 'react';

export function PixelCheckbox({
  checked,
  onClick,
  ariaLabel,
}: {
  checked: boolean;
  onClick: MouseEventHandler<HTMLSpanElement>;
  ariaLabel?: string;
}) {
  return (
    <span
      role="checkbox"
      aria-checked={checked}
      aria-label={ariaLabel ?? 'toggle'}
      tabIndex={0}
      className={`pixel-check ${checked ? 'done' : ''}`}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onClick(e as unknown as React.MouseEvent<HTMLSpanElement>);
        }
      }}
    />
  );
}
